import { Close, Lightbulb } from '@mui/icons-material';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import React, { Component } from 'react';
import axios from "axios";
import Global from "../../../customlib/Global";
import Api from "../../../customlib/Api";

class FuBlastTeleSetting extends Component {
    state = { 
        isDialogOpen: false,
        logs: [],
        isLoadingLog: false,
        isLoadingUpdateState: false
    } 

    loadGeneralSettingLogs = () => {
        this.setState({isLoadingLog: true}, () => {
            axios
                .post(Api.getGeneralSettingLogs(), {fieldName: "fuBlastTeleEnabled"}, Api.getRequestHeader())
                .then((response) => {
            
                    console.log("GENERAL_SSETTINGS", response.data);
                
                    var data = response.data;
                
                    this.setState({logs: data.data, isLoadingLog: false});
            
                })
                .catch((error) => {
                    this.setState({isLoadingLog: false});
                    console.error("There was an error!", error);
                });
        });
    }

    updateFuBlastTeleState = (isEnabled) => {
        this.setState({isLoadingUpdateState: true}, () => {
            axios
                .post(Api.updateFuBlastTeleState(), {enabled: isEnabled}, Api.getRequestHeader())
                .then((response) => {
            
                    console.log("GENERAL_SSETTINGS", response.data);
                    
                    this.setState({isLoadingUpdateState: false}, () => {
                        this.props.onReload();
                        this.loadGeneralSettingLogs();
                    });
            
                })
                .catch((error) => {
                    this.setState({isLoadingUpdateState: false});
                    console.error("There was an error!", error);
                });
        });
    }

    handleShowDialog = () => {
        this.setState({isDialogOpen: true}, () => {
            this.loadGeneralSettingLogs();
        });
    }

    handleCloseDialog = () => {
        this.setState({isDialogOpen: false, logs: []});
    }

    render() { 

        if(!Global.get().admin && !Global.isTeleAdmin()){
        // if(Global.get().admin || Global.isTeleAdmin()){
            return (
                <Paper 
                    sx={{backgroundColor: "#cccacaff", pt: "10px", pb: "10px", pl: "15px", pr: "15px"}}
                >
                    <Grid container spacing={1}>
                        <Grid item xs={10}>
                            <strong>Blast Akunke-2 Tele</strong>
                        </Grid>
                        <Grid item xs={2}>
                            <Lightbulb color={this.props.data?.fuBlastTeleEnabled ? "warning" : "default"} />                                    
                        </Grid>
                    </Grid>
                </Paper> 
            );
        }

        return (
            <Box>
                <Tooltip title={`FU Blast Tele (${this.props.data?.fuBlastTeleEnabled ? 'ON' : 'OFF'})`}>
                    <Paper 
                        sx={{backgroundColor: "#b9e4f6ff", cursor: "pointer", pt: "10px", pb: "10px", pl: "15px", pr: "15px"}}
                        onClick={this.handleShowDialog}
                    >
                        <Grid container spacing={1}>
                            <Grid item xs={10}>
                                <strong>Blast Akunke-2 Tele</strong>
                            </Grid>
                            <Grid item xs={2}>
                                <Lightbulb color={this.props.data?.fuBlastTeleEnabled ? "warning" : "default"} />                                    
                            </Grid>
                        </Grid>
                    </Paper> 
                </Tooltip> 

                <Dialog
                    open={this.state.isDialogOpen}
                    onClose={this.handleCloseDialog}
                    maxWidth={"lg"}
                    fullWidth
                    
                >
                    <DialogTitle id="alert-dialog-title">
                        
                        <Grid container spacing={1}>
                            <Grid item sm={10} xs={12}>{"FU Blast Tele"}</Grid>
                            <Grid item sm={2} xs={12} textAlign={"right"}>
                                <IconButton onClick={this.handleCloseDialog} color='error'><Close /></IconButton>
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <Divider />
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {
                                this.props.data?.fuBlastTeleEnabled && (
                                    <Grid container spacing={1}>
                                        <Grid item sm={10} xs={12}>Blast Akunke-2 Tele sedang <strong>Aktif</strong></Grid>
                                        <Grid item sm={2} xs={12} textAlign={"right"}>
                                            <Button 
                                                variant='contained' 
                                                color='error' 
                                                sx={{textTransform: "capitalize"}}
                                                onClick={() => this.updateFuBlastTeleState(false)}
                                                disabled={this.state.isLoadingUpdateState}
                                                fullWidth
                                            >
                                                Nonaktifkan!
                                            </Button>
                                        </Grid>
                                    </Grid>
                                )
                            }

                            {
                                !this.props.data?.fuBlastTeleEnabled && (
                                    <Grid container spacing={1}>
                                        <Grid item sm={10} xs={12}>Blast Akunke-2 Tele sedang <strong>Tidak Aktif</strong></Grid>
                                        <Grid item sm={2} xs={12} textAlign={"right"}>
                                            <Button 
                                                variant='contained' 
                                                color='primary' 
                                                sx={{textTransform: "capitalize"}}
                                                onClick={() => this.updateFuBlastTeleState(true)}
                                                disabled={this.state.isLoadingUpdateState}
                                                fullWidth
                                            >
                                                Aktifkan!
                                            </Button>
                                        </Grid>
                                    </Grid>
                                )
                            }
                        </DialogContentText>
                        <Divider sx={{mt: "10px", mb: "10px"}} />
                        <Typography variant='h6'>Riwayat Blast Akunke-2 Tele</Typography>
                        <TableContainer>
                            <Table size='small'>
                                <TableHead>
                                    <TableCell><strong>Tag</strong></TableCell>
                                    <TableCell><strong>Action</strong></TableCell>
                                    <TableCell><strong>By</strong></TableCell>
                                    <TableCell><strong>At</strong></TableCell>
                                </TableHead>
                                <TableBody>
                                {
                                    this.state.isLoadingLog && (
                                        <TableRow>
                                            <TableCell colSpan={4} textAlign={"center"}>Loading ... <CircularProgress size={"15px"} /></TableCell>
                                        </TableRow>
                                    )
                                }
                                {
                                    !this.state.isLoadingLog && this.state.logs?.map(item => {
                                        return (
                                            <TableRow>
                                                <TableCell width={"40%"}>{item.tag}</TableCell>
                                                <TableCell width={"20%"}>{item.newValue === true ? "Diaktifkan" : "Dinonaktifkan"}</TableCell>
                                                <TableCell width={"20%"}>{item.executorName}</TableCell>
                                                <TableCell width={"20%"}>{Global.formatDateTimeToStrDateTime24(item.created_at)}</TableCell>
                                            </TableRow>
                                        );
                                    })
                                }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContent>
                    <DialogActions>
                        {/* <Button onClick={()=>{}}>Disagree</Button>
                        <Button onClick={()=>{}} autoFocus>
                            Agree
                        </Button> */}
                    </DialogActions>
                </Dialog>

            </Box>
        );
    }
}
 
export default FuBlastTeleSetting;